import { render, staticRenderFns } from "./ScreenCinema.vue?vue&type=template&id=34f6ca23&"
import script from "./ScreenCinema.vue?vue&type=script&lang=js&"
export * from "./ScreenCinema.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCinema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports